// extracted by mini-css-extract-plugin
export default {"divider":"AttachmentAddPopup_divider__etuB1","menu":"AttachmentAddPopup_menu__tQMDc","menuItem":"AttachmentAddPopup_menuItem__xDicK","tip":"AttachmentAddPopup_tip__cCl40"};